import { render, staticRenderFns } from "./TTags.vue?vue&type=template&id=2b4e4f5a&scoped=true&"
import script from "./TTags.vue?vue&type=script&lang=ts&"
export * from "./TTags.vue?vue&type=script&lang=ts&"
import style0 from "./TTags.vue?vue&type=style&index=0&id=2b4e4f5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4e4f5a",
  null
  
)

export default component.exports